var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container pt-4"},[_c('el-tabs',{attrs:{"tab-position":"left"}},[_c('el-tab-pane',{attrs:{"label":"用户管理"}},[_c('user-management')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }